var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":_vm.post.slug}},[(_vm.post.template)?_c(_vm.post.template.replace('UpClose_', ''),{tag:"component",attrs:{"post":_vm.post}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }